<template>
  <div>
    <set-list-link
        v-if="initLayout"
        :listLayout="listLayout"
        :setData="List"
        :paginationData="filterSet.page"
        :setType="setType"
        :originData ='originData'
    ></set-list-link>
  </div>
</template>

<script>

import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import SetListLink from "@/components/set/SetListLink";
import setUtil from "@/components/set/setUtil";


const { filterConfig } = setUtil;
export default {
  name: "SetListComponent",
  mixins: [
    alertMixins,
    filterMixins,
    listMixins,
    setUtil,
  ],
  components: {SetListLink},
  inject: ["changeLoading"],
  provide() {
    return {
      // setPage: this.setPage,
      // setFilter: this.setFilter,
      setListSetData: this.setData,
      setListDelete: this.runDeleteConfirm,
    };
  },

  props: {
    setType: "",
    originData : {}
  },
  data() {
    return {
      listLayout: "",
      listApiParamSet: {},
      filterLayout: "",
      paginationLayout: "",
      paginationType: "",
      getFunc: "",
      deleteFunc: "",
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      deleteErrorTypes: [],
      keyName: "",
      selectArr: [],
      DeleteClass: null,
      deleteIndex: 0,
      deleteLastIndex: 0,
      filterDate: "",
      filterSort: false,
      initLayout : false,

    };
  },
  created() {
    this.setFilterConfig(filterConfig);
    this.setParserType("url", this.$route.fullPath);
    this.initConfig();
  },
  mounted() {
    this.getList(true);
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    initConfig() {
      let setFilterConfig = this.returnSetConfig(this.setType);
      this.filterLayout = setFilterConfig.filterLayout;
      this.paginationLayout = setFilterConfig.paginationLayout;
      this.listApiParamSet = setFilterConfig.listApiParamSet;
      this.paginationType = setFilterConfig.paginationType;
      this.getFunc = setFilterConfig.getFunc;
      this.deleteFunc = setFilterConfig.deleteFunc;
      this.deleteApiParamsSet = setFilterConfig.deleteApiParamsSet;
      this.deleteSuccessType = setFilterConfig.deleteSuccessType;
      this.deleteFailTypes = setFilterConfig.deleteFailTypes;
      this.keyName = setFilterConfig.keyName;
      let listOptions = {
        url: this.$api.$config[this.getFunc],
        defaultParams: this.listApiParamSet,
      };
      this.initList("api", listOptions);
      this.initTemplateConfig();
    },
    initTemplateConfig(){
      let setFilterConfig = this.returnSetConfig(this.setType);
      this.listLayout = '';
      this.listLayout = setFilterConfig.listLayout;
      this.initLayout = true
    },
    runDeleteConfirm() {
      if (this.selectArr.length === 0) {
        this.errorAlert("목록을 선택해주세요.");
        return false;
      }
      this.createConfirm({
        content: "정말 삭제하시겠습니까?",
        confirm: () => {
          this.deleteIndex = 0;
          this.deleteLastIndex = this.selectArr.length - 1;
          this.runDelete();
        },
      });
    },
    runDelete() {
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
    },
    deleteAfterFunc() {
      if (this.deleteIndex < this.deleteLastIndex) {
        this.deleteIndex = this.deleteIndex + 1;
        this.runDelete();
      } else {
        this.changeLoading(false);
        this.createAlert({
          content: "삭제되었습니다.",
          hide: () => {
            this.getList();
          },
        });
      }
    },


  },
  watch: {
    setType: {
      deep: true,
      handler: function (val, oldVal) {
        this.setFilterConfig(filterConfig);
        this.setParserType("url", this.$route.fullPath);
        this.initLayout = false;
        this.initConfig();
        this.$nextTick(() => {
          this.getList(true);
        });
      }
    }
  },
};
</script>

<style scoped></style>
